module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAPCAYAAADzun+cAAAAAXNSR0IArs4c6QAAALZJREFUOBFjZCAAUh+6uDAw/LcloAxNmvHwbPk9e9AEUbhMKDw0Tu5/T/b/DP93/2di/EcSBupp+J/AgWYcCpcFhYeVw/hrjuyeRqxSOASBoVSJQwoujNfHcFU0YIxaTINAxW7kaFBjDxcaiI4GNQ0CFbuRLKkPnXEWhz8e/WYHVhBs2LXiFgWW7+xPHz+pBpr9D5cqFlDhj0sSKP6dhYnJBo88VikWFiabP//+uzAwMmKVBwkCAHeUQIsY1i3ZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hcp-icon/legend/basal.png
// module id = 109
// module chunks = 7